module.exports = __webpack_public_path__ + "static/media/HUK.b37f9dac.svg";